/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// copy from https://github.com/facebook/lexical/blob/main/packages/lexical-react/src/shared/useList.ts
//

import {
	$handleListInsertParagraph,
	INSERT_ORDERED_LIST_COMMAND,
	INSERT_UNORDERED_LIST_COMMAND,
	insertList,
	REMOVE_LIST_COMMAND,
	removeList,
} from '@lexical/list'
import {mergeRegister} from '@lexical/utils'
import {COMMAND_PRIORITY_LOW, INSERT_PARAGRAPH_COMMAND} from 'lexical'

export function useList(editor) {
	return mergeRegister(
		editor.registerCommand(
			INSERT_ORDERED_LIST_COMMAND,
			() => {
				insertList(editor, 'number')
				return true
			},
			COMMAND_PRIORITY_LOW,
		),
		editor.registerCommand(
			INSERT_UNORDERED_LIST_COMMAND,
			() => {
        console.log("INSERT_UNORDERED_LIST_COMMAND")
				insertList(editor, 'bullet')
				return true
			},
			COMMAND_PRIORITY_LOW,
		),
		editor.registerCommand(
			REMOVE_LIST_COMMAND,
			() => {
				removeList(editor)
				return true
			},
			COMMAND_PRIORITY_LOW,
		),
		editor.registerCommand(
			INSERT_PARAGRAPH_COMMAND,
			() => {
				const hasHandledInsertParagraph = $handleListInsertParagraph()

				if (hasHandledInsertParagraph) {
					return true
				}

				return false
			},
			COMMAND_PRIORITY_LOW,
		),
	)
}
